import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { API, CustomAxiosError } from "../../../../../logics/api-config";

export interface UpdateNotAccountedNotePayload {
    ris_id: number;
    note: string;
}

const useApiUpdateNotAccountedNote = (
    invalidateKeys?: (string | number)[]
): UseMutationResult<void, CustomAxiosError, UpdateNotAccountedNotePayload, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<void, CustomAxiosError, UpdateNotAccountedNotePayload>(
        async ({ ris_id, note }) => {
            const payload = {
                note: note
            };
            await API.put(`/accounting/recap/restaurant/${ris_id}/set_not_accounted_note`, payload);
        },
        {
            onSuccess: async () => {
                if (invalidateKeys && invalidateKeys.length > 0) {
                    await queryClient.invalidateQueries(invalidateKeys);
                } else {
                    await Promise.all([
                        queryClient.invalidateQueries(["getAccountingStripeRecap"]),
                        queryClient.invalidateQueries(["getAccountingCashRecap"]),
                        queryClient.invalidateQueries(["getAccountingBookingRecap"]),
                    ]);
                }
            },
        }
    );
};

export default useApiUpdateNotAccountedNote;
